var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineGemini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61 2.65a.749.749 0 0 1-.26-1.03c.21-.36.67-.47 1.03-.26 5.93 3.56 13.3 3.56 19.23 0a.751.751 0 1 1 .77 1.29 20.156 20.156 0 0 1-20.77 0zM21.61 22.64a18.647 18.647 0 0 0-19.23 0 .751.751 0 1 1-.77-1.29 20.164 20.164 0 0 1 20.77 0c.36.21.47.67.26 1.03a.742.742 0 0 1-1.03.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97 21.07c-.36-.2-.5-.65-.3-1.02 2.68-4.96 2.71-10.9.09-15.88l-.12-.24a.746.746 0 0 1 .32-1.01c.37-.19.82-.05 1.01.32l.12.24a18.38 18.38 0 0 1-.1 17.29c-.13.25-.39.39-.66.39-.12 0-.24-.03-.36-.09zM18.01 20.77a18.38 18.38 0 0 1-.1-17.29l.12-.24a.75.75 0 1 1 1.33.69l-.12.24a16.882 16.882 0 0 0 .09 15.88c.2.37.06.82-.3 1.02-.12.06-.24.09-.36.09-.27 0-.52-.14-.66-.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGemini);
export default __webpack_public_path__ + "static/media/vuesax-outline-gemini.79bab6ad31797a127ed2f8ae16730375.svg";
export { ForwardRef as ReactComponent };